import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../utils/Constants";

const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return { headers: { Authorization: token } };
};

export const postQuestion = createAsyncThunk(
  "postQuestion/postQuestion",
  async (formData, { rejectWithValue }) => {
    try {
      await axios.post(
        `${baseUrl}/postQuestion`,
        formData,
        getAuthHeader()
      );
      return true;
    } catch (err) {
      return rejectWithValue("Failed to post question");
    }
  }
);

const postQuestionSlice = createSlice({
  name: "postQuestion",
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {
    resetPostQuestionState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postQuestion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postQuestion.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(postQuestion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetPostQuestionState } = postQuestionSlice.actions;
export default postQuestionSlice.reducer;